import { Link, Typography } from '@mui/material';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { OkDlg } from '../../../../general/dialogs/ok-dlg';
import { RootState } from '../../../../store';
import { gotoVerifyApp, gotoCreditApp } from '../../../../store/actions/route';

type Props = {
  onClose: () => void;
  context: {
    conflict: 'existing_verify_application' | 'existing_credit_application';
  };
};

const ExistingApplicationDlg: FC<Props> = ({ onClose, context: { conflict } }: Props) => {
  const dispatch = useDispatch();
  const creditAppUrl = useSelector((state: RootState) => state.config.config!.creditAppUrl);
  const verifyAppUrl = useSelector((state: RootState) => state.config.config!.verifyAppUrl);

  const handleOk = () => {
    onClose();
    if (conflict === 'existing_credit_application') {
      dispatch(gotoCreditApp());
    } else {
      dispatch(gotoVerifyApp());
    }
  };

  const url = conflict == 'existing_credit_application' ? creditAppUrl : verifyAppUrl;
  const host =
    conflict === 'existing_credit_application' ? new URL(creditAppUrl).hostname : new URL(verifyAppUrl).hostname;

  return (
    <OkDlg
      content={
        <>
          <Typography variant="subtitle1" align="center">
            You&apos;ve already started an application with this phone number. Please go to{' '}
            <Link href={url}>{host}</Link> to complete it.
          </Typography>
        </>
      }
      title="Complete Application"
      okLabel="Take Me There"
      onOk={handleOk}
      onClose={onClose}
    />
  );
};

export { ExistingApplicationDlg };
